import React from 'react';

const Textarea = ({ label, type = "text", placeholder, onChange, value, custom, disabled, name, register, error }) => {

  const isError = error ? "input-wrapper-error" : "";

  return (
    <div className={`input-wrapper ${custom} ${isError}`}>
      <label className="input-label">{label}</label>
      <textarea rows="5" className="input" style={{ height: "200px", paddingTop: "10px", paddingBottom: "10px" }} type={type} placeholder={placeholder} onChange={onChange} value={value} disabled={disabled} {...register(name)} ></textarea>
      {error && <div className="mt-10 text-error">{error.message}</div>}
    </div>
  );
}

export default Textarea;